@use '@/sass/variables';

.tagsInputWrapper {
  max-height: 360px;
  overflow-y: auto;
  max-width: 100%;

  input[type='text'].tagsInput {
    border-radius: 3px;
    min-width: 14rem;
    outline: none;
    white-space: nowrap;
    margin-bottom: 0;

    &:disabled {
      background: transparent;
      cursor: not-allowed;
    }
  }
}

.tagsList {
  display: flex;
  flex-flow: row wrap;
  flex-shrink: 0;
  padding: 0;
  list-style: none;
  margin: 0 0 0.25rem 0;

  .tag {
    display: inline-flex;
    align-items: center;
    margin: 5px 3px;
    padding: 0.1rem 0.3rem 0.1rem 0.4rem;
    border-radius: 3px;
    background: variables.$moon-gray;
    color: variables.$near-black;
    font-size: 0.75rem;

    .tagRemove {
      background: none;
      border: 0;
      cursor: pointer;
      text-decoration: none;
      color: variables.$dark-gray;
      margin-left: 5px;

      &:hover,
      &:focus-visible {
        color: variables.$dark-red;
      }
    }
  }
}

.insideTagsInput {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: text;
  min-height: 2.5rem;
  padding-left: 0.2rem;

  &:focus-within {
    border-color: variables.$blue;
  }

  .tagsList {
    display: inline-flex;
    margin: 0;
    width: 100%;
  }

  input[type='text'].tagsInput {
    border: 0;
    border-radius: 0;
    width: 1px;
    max-width: none;
    height: auto;
    margin: 5px 3px;
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
    line-height: 1.2;
    min-width: auto;
    flex-grow: 1;

    &:focus {
      border: 0;
      border-radius: 0;
      box-shadow: none;
      outline: none;
    }
  }
}
